import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { useHomepageData } from '@/hooks/useHomepageData';
import { Header } from '@/components/layout/Header.tsx';
import { Footer } from '@/components/layout/Footer.tsx';
import { Hero } from '@/components/sections/Hero.tsx';
import { ImportantNotices } from '@/components/sections/ImportantNotices.tsx';
import { NewsUpdates } from '@/components/sections/NewsUpdates.tsx';
import { LearnToFly } from '@/components/sections/LearnToFly.tsx';
import { StudentMilestones } from '@/components/sections/StudentMilestones.tsx';
import { Services } from '@/components/sections/Services.tsx';

export function Index() {
  const { siteData } = useSiteData();
  const { homepageData } = useHomepageData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <Hero />
        
        <ImportantNotices notices={homepageData.importantNotices} />
        
        <NewsUpdates 
          articles={homepageData.newsArticles} 
          currentConditions={homepageData.currentConditions}
        />
        
        <LearnToFly data={homepageData.learnToFly} />
        
        <Services data={homepageData.services} />
        
        <StudentMilestones data={homepageData.studentMilestones} />
        
        <Footer data={siteData.footer} />
      </div>
    </>
  );
}